import { wrap } from "svelte-spa-router/wrap";

function guardAuth() {
  const token = localStorage.getItem("slipstream_token");
  if (!token) {
    window.location.hash = "#/login";
    return false;
  }
  return true;
}

function redirectHome() {
  const token = localStorage.getItem("slipstream_token");
  if (token) {
    window.location.hash = "#/dashboard";
  } else {
    window.location.hash = "#/login";
  }
  return false;
}

export const routes = {
  "/": wrap({
    asyncComponent: () => import("../routes/Login.svelte"),
    conditions: [redirectHome],
  }),
  "/login": wrap({
    asyncComponent: () => import("../routes/Login.svelte"),
  }),
  "/dashboard": wrap({
    asyncComponent: () => import("../routes/Dashboard.svelte"),
    conditions: [guardAuth],
  }),
  "/sources": wrap({
    asyncComponent: () => import("../routes/Sources.svelte"),
    conditions: [guardAuth],
  }),
  "/repos": wrap({
    asyncComponent: () => import("../routes/Repos.svelte"),
    conditions: [guardAuth],
  }),
  "/packages": wrap({
    asyncComponent: () => import("../routes/Packages.svelte"),
    conditions: [guardAuth],
  }),
  "/products": wrap({
    asyncComponent: () => import("../routes/Products.svelte"),
    conditions: [guardAuth],
  }),
  "/consumers": wrap({
    asyncComponent: () => import("../routes/Consumers.svelte"),
    conditions: [guardAuth],
  }),
  "/storage": wrap({
    asyncComponent: () => import("../routes/Storage.svelte"),
    conditions: [guardAuth],
  }),
  "/storage/*": wrap({
    asyncComponent: () => import("../routes/Storage.svelte"),
    conditions: [guardAuth],
  }),
  "/settings": wrap({
    asyncComponent: () => import("../routes/Settings.svelte"),
    conditions: [guardAuth],
  }),
  "/runtime": wrap({
    asyncComponent: () => import("../routes/Runtime.svelte"),
    conditions: [guardAuth],
  }),
  "/graph": wrap({
    asyncComponent: () => import("../routes/DependencyGraph.svelte"),
    conditions: [guardAuth],
  }),
  "*": wrap({
    asyncComponent: () => import("../routes/Login.svelte"),
    conditions: [redirectHome],
  }),
};
